import { SWRConfig } from 'swr';
import { useAccessToken } from '~/hooks';

const API = import.meta.env.VITE_API_URL || ''

export interface SWRContextProps {
  children?: React.ReactNode
}

function SWRContext({ children }: SWRContextProps) {
  const [_, getAccessToken] = useAccessToken()

  return (
    <SWRConfig
      value={{
        fetcher: async (url: string) => {
          try {
            const accessToken = await getAccessToken()
            if (!accessToken) {
              throw new Error('No access token available')
            }
            url = `${API}${url}`
            const response = await fetch(url, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              }
            })
            
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }
            
            return await response.json()
          } catch (error) {
            console.error('SWR fetcher error:', error)
            throw error
          }
        },
      }}
    >
    {children}
    </SWRConfig>
  )
}

export default SWRContext